import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { ExtrairPage } from '../pages/extrair/extrair';
import { AcompanharPage } from '../pages/acompanhar/acompanhar';
import { AguardandoPage } from '../pages/aguardando/aguardando';
import { AceitoPage } from '../pages/aceito/aceito';
import { FormunicoPage } from '../pages/formunico/formunico';
import { AdministraPage } from '../pages/administra/administra';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    AdministraPage,
    FormunicoPage,
    AguardandoPage,
    AceitoPage,
    AcompanharPage,
    ExtrairPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    FormunicoPage,
    AguardandoPage,
    AceitoPage,
    AdministraPage,
    ListPage,
    AcompanharPage,
    ExtrairPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts